import { useState } from 'react'

const useSearchAndRotation = () => {
  const [searchQuery, setSearchQuery] = useState('')
  const [rotated, setRotated] = useState(false)

  const handleClearSearch = () => setSearchQuery('')
  const handleRotate = () => setRotated(!rotated)

  return {
    searchQuery,
    setSearchQuery,
    rotated,
    setRotated,
    handleClearSearch,
    handleRotate,
  }
}

export default useSearchAndRotation
